/* 📁 ASSETS*/
import { Arrow } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TotalContainer, NameContainer, ValuesContainer, ArrowContainer, ArrowIMG, NameText, OldValueText, NewValueText } from "./styles";

import { useTranslation } from "react-i18next";

const ConfirmComandTitle = ({ total }) => {
    const { t } = useTranslation();

    return(
        <Container>
            <NameContainer>
                <NameText>
                    {t("modal.confirm-changes.title")}
                </NameText>
            </NameContainer>

            <ValuesContainer>
                <OldValueText>
                    {t("modal.confirm-changes.all")}
                </OldValueText>
            </ValuesContainer>

            <ArrowContainer>
                <ArrowIMG src={Arrow}/>
            </ArrowContainer>
            <ValuesContainer>
                <TotalContainer>
                    <NewValueText>
                        {total}
                    </NewValueText>
                </TotalContainer>
            </ValuesContainer>
        </Container>
    )
}

export default ConfirmComandTitle;